import {BaseTerms} from "../../infrastructure/models/base-terms";

export class ScoresListHeaderModuleTerms extends BaseTerms {}
